<template>
  <a v-if="href" :href="href">
    <slot />
  </a>
  <router-link v-else :to="to">
    <slot />
  </router-link>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: null,
    },
    to: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped>
.link {
  @apply text-white font-bold transition-all duration-300;
}
.link:hover {
  @apply underline;
  text-shadow: 0 0 4px rgba(255, 255, 255, 0.8);
}
</style>
